import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import styles from './ExpandableCard.module.css';
import { IoIosArrowDown } from 'react-icons/io';

const ExpandableCard = ({
  headerTitle,
  headerIcon,
  header,
  headerColor = 'var(--Utility_Color1)',
  bodyColor = 'var(--Utility_Color1)',
  fileLinks = [],
  notes,
  time,
  date,
  defaultOpen = true,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div
      className={styles.ExpandableCard}
      style={{ '--custom-color': headerColor, '--body-color': bodyColor }}
    >
      <header className={styles.cardHeader} onClick={() => setIsOpen(!isOpen)}>
        <section className={styles.headerLeft}>
          {headerTitle && <p className={styles.headerTitle}>{headerTitle}</p>}
          {headerIcon}
          {header}
        </section>
        <section className={styles.headerRight}>
          <motion.span
            className={styles.Arrowicon}
            animate={{ rotate: isOpen ? 180 : 0 }}
            transition={{ duration: 0.25 }}
          >
            <IoIosArrowDown />
          </motion.span>
        </section>
      </header>
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            className={styles.content}
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: 'easeInOut' }}
          >
            <div className={styles.innerContent}>{children}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default ExpandableCard;
